module.exports = __webpack_public_path__ + "media/images/icons/elevator-d421f0d7fff04cc88c4864c9e68ef73d.svg";